import { render, staticRenderFns } from "./PersonalNews.vue?vue&type=template&id=6cff23e4"
import script from "./PersonalNews.vue?vue&type=script&lang=js"
export * from "./PersonalNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports